import { Button, CircularProgress } from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { useTranslation } from 'react-i18next';

type GenerateTestCaseButtonProps = {
  selectedCount: number;
  generating: boolean;
  disabled: boolean;
  resumeAvailable?: boolean;
  onClick: () => void;
};

export const GenerateTestCaseButton = ({
  selectedCount,
  generating,
  disabled,
  resumeAvailable = false,
  onClick,
}: GenerateTestCaseButtonProps) => {
  const { t } = useTranslation('testCases');

  let buttonLabel = t('testCaseGeneration.actions.generateSingle');

  if (generating) {
    buttonLabel = t('testCaseGeneration.actions.generating');
  } else if (resumeAvailable) {
    buttonLabel = t('testCaseGeneration.actions.resume');
  } else if (selectedCount > 1) {
    buttonLabel = t('testCaseGeneration.actions.generateMultiple');
  }

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled || generating}
      onClick={onClick}
      startIcon={
        generating ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <AssignmentTurnedInIcon />
        )
      }
    >
      {buttonLabel}
    </Button>
  );
};
